export const CAL_STEPS = ["Started", "Employee self-rating", "Your blind rating", "Compare", "Conversation held"];

export function calStage(c) {
  const emp = !!c.employee_submitted;
  const mgr = !!c.manager_submitted;
  const complete = emp && mgr;
  const held = complete && !!c.conversation_held_on;
  const done = [true, emp, mgr, complete, held];
  const firstTodo = done.indexOf(false);
  const current = firstTodo === -1 ? done.length : firstTodo;
  const label = held ? "Complete"
    : complete ? "Ready to discuss"
    : !emp && !mgr ? "Awaiting both ratings"
    : !emp ? "Awaiting employee"
    : "Awaiting your rating";
  return { done, current, label, emp, mgr, complete, held };
}

export function formatHeldDate(d) {
  if (!d) return "";
  const [y, m, day] = d.split("-").map(Number);
  return new Date(y, m - 1, day).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
}
